import React from "react";
import { Container } from "react-bootstrap";

const OfferWrapper = ({ children }) => {
  return <Container className="my-4">{children}</Container>;
};

export default OfferWrapper;
